import { z } from "zod";

import { confidenceSchema, observationSourceSchema } from "./observation.js";

const contactTerritoryDetailChangeSchema = z.discriminatedUnion("field", [
  z
    .object({
      entityType: z.literal("contact"),
      field: z.literal("email"),
      value: z
        .string()
        .trim()
        .max(320)
        .refine(
          (value) => value.length === 0 || z.email().safeParse(value).success,
          { message: "A non-empty Contact email must be valid." },
        ),
      source: observationSourceSchema,
      confidence: confidenceSchema,
    })
    .strict(),
  z
    .object({
      entityType: z.literal("contact"),
      field: z.literal("phone"),
      value: z.string().trim().max(100),
      source: observationSourceSchema,
      confidence: confidenceSchema,
    })
    .strict(),
  z
    .object({
      entityType: z.literal("contact"),
      field: z.literal("title"),
      value: z.string().trim().max(200),
      source: observationSourceSchema,
      confidence: confidenceSchema,
    })
    .strict(),
  z
    .object({
      entityType: z.literal("contact"),
      field: z.literal("is_active"),
      value: z.boolean(),
      source: observationSourceSchema,
      confidence: confidenceSchema,
    })
    .strict(),
]);

const labTerritoryDetailChangeSchema = z
  .object({
    entityType: z.literal("lab"),
    field: z.literal("room_or_suite"),
    value: z.string().trim().min(1).max(200).nullable(),
    source: observationSourceSchema,
    confidence: confidenceSchema,
  })
  .strict();

export const territoryDetailChangeSchema = z.union([
  contactTerritoryDetailChangeSchema,
  labTerritoryDetailChangeSchema,
]);
export type TerritoryDetailChange = z.infer<typeof territoryDetailChangeSchema>;
